import React, { createContext, useState, useEffect, useContext } from 'react';
import { ConquerContext } from './ConquerContext';

export const UserContext = createContext();

const UserContextProvider = (props) => {

    const conquer = useContext( ConquerContext );
    const [userData, setUserData] = useState( { isLogged: false } );

    function loadUser() {
        async function asyncLoad() {

            if( !conquer ) return setUserData( { isLogged: false } );

            let newData = Object.assign( {}, conquer.User );
            newData.isLogged = newData && newData.type != 'GUEST' && newData.token && true;
            setUserData( newData );
        }

        asyncLoad();
    }
    useEffect(loadUser, [conquer.initialized]);

    useEffect( function(){

        if( conquer ) conquer.Signal.get( 'AUTH:onLogin', loadUser );
        return () => conquer && conquer.Signal.remove( 'AUTH:onLogin', loadUser );

    }, [conquer])

    return (
        <UserContext.Provider value={{userData, refresh: loadUser}}>
            {props.children}
        </UserContext.Provider>
    );
};
export default UserContextProvider;
